import React, { useState, useEffect, useCallback } from 'react';
import BuyerPortalLayout from '../../components/buyer/BuyerPortalLayout';
import { fetchBuyerProfile, updateBuyerProfile } from '../../lib/buyerApi';

const BuyerProfilePage: React.FC = () => {
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState({ full_name: '', phone: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchBuyerProfile();
      const p = res.profile || res;
      setProfile(p);
      setForm({ full_name: p.full_name || '', phone: p.phone || '' });
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSave = async () => {
    setSaving(true); setSaved(false);
    try { await updateBuyerProfile(form); setSaved(true); setTimeout(() => setSaved(false), 3000); }
    catch (err: any) { alert(err.message || 'Failed to save'); }
    finally { setSaving(false); }
  };

  return (
    <BuyerPortalLayout title="Profile & Settings">
      {loading ? (
        <div className="flex items-center justify-center py-16"><div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : (
        <div className="max-w-3xl mx-auto space-y-6">
          <div className="flex justify-end">
            <button onClick={handleSave} disabled={saving}
              className="px-5 py-2.5 bg-emerald-600 text-white text-sm font-bold rounded-xl hover:bg-emerald-700 disabled:opacity-50 transition">
              {saving ? 'Saving...' : saved ? '✓ Saved' : 'Save Changes'}
            </button>
          </div>

          <div className="bg-white border border-gray-100 rounded-2xl p-6">
            <h3 className="text-sm font-bold text-gray-900 mb-4">Personal Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                <input type="text" value={form.full_name} onChange={e => setForm({ ...form, full_name: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm" /></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" value={profile?.email || ''} disabled
                  className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm bg-gray-50 text-gray-500" />
                <p className="text-xs text-gray-400 mt-1">Email cannot be changed</p></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                <input type="tel" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm" placeholder="+250 7XX XXX XXX" /></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Buyer Type</label>
                <input type="text" value={profile?.organisations?.length > 0 ? 'Organisation Buyer' : 'Individual Buyer'} disabled
                  className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm bg-gray-50 text-gray-500" /></div>
            </div>
          </div>

          {/* Organisation Memberships */}
          {profile?.organisations && profile.organisations.length > 0 && (
            <div className="bg-white border border-gray-100 rounded-2xl p-6">
              <h3 className="text-sm font-bold text-gray-900 mb-4">Organisation Memberships</h3>
              <div className="space-y-3">
                {profile.organisations.map((org: any) => (
                  <div key={org.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                    <div>
                      <p className="text-sm font-medium text-gray-900">{org.name}</p>
                      <p className="text-xs text-gray-500">Role: {org.membership_role || 'Member'}</p>
                    </div>
                    <span className={`px-2 py-0.5 rounded text-xs font-bold ${org.membership_status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'}`}>
                      {org.membership_status || 'Active'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </BuyerPortalLayout>
  );
};

export default BuyerProfilePage;
